import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { Button } from '@labsavvyapp/components'
import { useOrdersetSettingsPageBusinessLogic } from '../../../../logic/context'
import { OrdersetListFilters } from './components'

const OrdersetSettingsHeaderControlsLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  gap: 10px;
`

export const CreateOrdersetHeaderControls = () => {
  const pageLogic = useOrdersetSettingsPageBusinessLogic()
  const createOrdersetForm = pageLogic?.createOrdersetForm ?? null
  const payload = pageLogic?.createOrdersetForm.values ?? null
  const existingOrdersets = pageLogic?.ordersetList ?? []
  const isNameExisting = existingOrdersets.some((orderset) => orderset.name.toLowerCase() === payload.name.toLowerCase())

  useEffect(() => {
    if (isNameExisting) {
      createOrdersetForm.setFieldError('name', 'This orderset name already exists. Please choose another name or click Cancel.')
    }
  }, [isNameExisting])

  const handleSaveOrdersetClick = () => {
    pageLogic?.createNewOrderset()
  }

  const handleCancelClick = () => {
    pageLogic?.goToOrdersetListPage()
  }

  return (
    <OrdersetSettingsHeaderControlsLayout>
      <OrdersetListFilters />

      <Button radius="xl" size="md" uppercase variant="subtle" onClick={handleCancelClick}>
        Cancel
      </Button>
      <Button
        radius="xl"
        size="md"
        uppercase
        variant="filled"
        onClick={handleSaveOrdersetClick}
        disabled={!createOrdersetForm.isValid() || isNameExisting}
      >
        Save Orderset
      </Button>
    </OrdersetSettingsHeaderControlsLayout>
  )
}
